<div class="ui-breadcrumbs__holder">
  <div class="ui-breadcrumbs__holder__breadcrumbs">
    <a routerLink="{{ baseUrl }}">
      @if (baseIcon) {
        <campus-icon [svgIcon]="baseIcon"></campus-icon>
      } @else {
        <span class="ui-breadcrumbs__crumb">{{ baseDisplayText }}</span>
      }
    </a>
  </div>
  @if (breadcrumbs.length > maxLength) {
    <div class="ui-breadcrumbs__holder__breadcrumbs">
      @if (separator) {
        <campus-icon
          [svgIcon]="separator"
          class="ui-breadcrumbs__separator"
        ></campus-icon>
      } @else {
        <span class="ui-breadcrumbs__separator" [innerHTML]="separatorCharacter"></span>
      }
      <span class="ui-breadcrumbs__crumb">{{ overflowedLinkString }}</span>
    </div>
  }
  @for (breadcrumb of breadcrumbs | slice: -(maxLength - 1); track breadcrumb; let last = $last) {
    <div
      class="ui-breadcrumbs__holder__breadcrumbs"
      >
      @if (separator) {
        <campus-icon
          [svgIcon]="separator"
          class="ui-breadcrumbs__separator"
        ></campus-icon>
      } @else {
        <span class="ui-breadcrumbs__separator" [innerHTML]="separatorCharacter"></span>
      }
      <a
        [routerLink]="!last || canClickLastItem ? breadcrumb.link : null"
        [queryParams]="breadcrumb.queryParams"
        class="ui-breadcrumbs__crumb"
        >{{ breadcrumb.displayText }}</a
        >
      </div>
    }
  </div>

